import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export default function Invite() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => { api.get(`/invites/${token}`).then((r) => setInfo(r.data)).catch((e) => setError(errMsg(e))); }, [token]);

  const ask = async () => {
    try { const { data } = await api.post(`/invites/${token}/request`); setInfo({ ...info, status: data.status }); toast.success("Request sent"); } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="max-w-md mx-auto px-5 py-16" data-testid="invite-page">
      <div className="rounded-3xl bg-white border border-stone-200 p-8 text-center space-y-4 rise">
        <Lock className="w-8 h-8 mx-auto text-[#163A2B]" />
        {error && <p data-testid="invite-error" className="text-stone-600">{error}</p>}
        {info && (
          <>
            <h1 className="text-3xl font-extrabold tracking-tight">{info.owner_name} invited you</h1>
            <p className="text-stone-600">to ask for access to <strong>{info.title}</strong>. Nothing is visible until {info.owner_name} approves you.</p>
            {info.status === "none" && <button data-testid="invite-request-btn" onClick={ask} className="w-full bg-[#2F7D55] hover:bg-[#23603F] text-white font-semibold py-3 rounded-xl">Ask for access</button>}
            {info.status === "pending" && <p data-testid="invite-pending" className="text-sm font-semibold text-amber-800 bg-amber-50 rounded-xl py-3">Request sent. Waiting for approval.</p>}
            {["has_access", "owner"].includes(info.status) && <Link data-testid="invite-open-plan" to={`/plans/${info.plan_id}`} className="block w-full bg-[#163A2B] text-white font-semibold py-3 rounded-xl">Open the plan</Link>}
          </>
        )}
      </div>
    </div>
  );
}
